import { BaseHub } from './base-hub';

// ---

type MatchId = number;

export type SubscriptionsExtArgs = {
  Type: 'Match' | 'MatchGroup';
  Sports?: number[];
  Matches?: MatchId[];
  StakesFilter?: 'MainLine';
  matchGroupName?: string;
  onlyCustomStakeNames?: boolean;
};

export class SubscribeExtHub extends BaseHub {
  public subscribe = (topic: string, args: SubscriptionsExtArgs) => {
    //Дока по переходу на api v2 https://confluence.tennisi.it/pages/viewpage.action?pageId=829423924
    const methodName = this.isBackendApiV2 ? 'subscribe-ext-v2' : 'subscribe-ext';
    const payload = this.isBackendApiV2? [0, args] : args;
    return this.hubConnection.invoke(methodName, topic, payload);
  };

  public unsubscribe = (topic: string) => {
    return this.hubConnection.invoke('unsubscribe', topic);
  };
}
